import { parsePhoneNumberFromString, formatIncompletePhoneNumber, CountryCode } from 'libphonenumber-js';

// País usado para números digitados sem código do país (deve ser o mesmo DEFAULT_PHONE_COUNTRY do backend)
export const DEFAULT_PHONE_COUNTRY: CountryCode = 'AE';

export function formatPhoneNumber(phoneNumber: string): string {
  const parsed = parsePhoneNumberFromString(phoneNumber, DEFAULT_PHONE_COUNTRY);
  if (parsed) {
    // Formato nacional só para números do país padrão; os demais mostram o código do país
    return parsed.country === DEFAULT_PHONE_COUNTRY ? parsed.formatNational() : parsed.formatInternational();
  }
  return phoneNumber;
}

export function normalizePhoneInput(input: string): string {
  return formatIncompletePhoneNumber(input, DEFAULT_PHONE_COUNTRY);
}

export function validatePhone(phoneNumber: string): boolean {
  const parsed = parsePhoneNumberFromString(phoneNumber, DEFAULT_PHONE_COUNTRY);
  return parsed ? parsed.isValid() : false;
}
